module.exports = __webpack_public_path__ + "img/login.ae71db31.png";